import React from 'react';

const Question = ({ questionText }) => (
  <>
    <div className="question-text">What is</div>
    <div className="question">{questionText}</div>
  </>
);

export default Question;